// import { BrowserRouter,Routes,Route } from "react-router-dom";
// import Register from "./components/Register";
// import Login from "./components/Login";
 
// import Home from "./components/Home";


// function App() {
//   return (
//     <div>

//       <BrowserRouter>
//             <Routes>
//               <Route path="/home" element= { <Home/>} />
//               <Route path="/register" element= { <Register/>} />
//               <Route path="/" element= { <Login/>} />
//             </Routes>
//         </BrowserRouter>
      
//     </div>
//   );
// }

// export default App;

// JWT Token based//
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import Home from "./components/Home";
// import Login from "./components/Login";
// //import RoomsPage from "./components/RoomsPage";
// import AdminDashboard from "./pages/AdminDashboard";
// import ManageRooms from "./pages/ManageRooms";
// import AddRoom from "./pages/AddRoom";
// import EditRoom from "./pages/EditRoom";
// import RoomList from "./components/RoomList";
// import RoomBooking from "./components/RoomBooking";
// import RoomAvailability from "./components/RoomAvailability";

// //import Login from "./auth/Login";
// import Register from "./auth/Register";
// import BookingHistory from "./components/BookingHistory";
// //import AddRoom from "./components/AddRoom";
// import ProtectedRoute from "./components/ProtectedRoute";

// export default function App() {
//   return (
//     // <Router>
//     //   <Navbar />
//     //   <Routes>
//     //     <Route path="/" element={<Home />} />
//     //     <Route path="/login" element={<Login />} />
//     //     <Route path="/rooms" element={<RoomsPage />} />
//     //   </Routes>
//     // </Router>

//     <BrowserRouter>
//       <Navbar />

//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/admin" element={<AdminDashboard />} />
//         <Route path="/manage-rooms" element={<ManageRooms />} />
//         <Route path="/add-room" element={<AddRoom />} />
//         <Route path="/edit-room/:id" element={<EditRoom />} />
//         <Route path="/" element={<RoomList />} />
//         <Route path="/book/:id" element={<RoomBooking />} />
//         <Route path="/" element={<RoomAvailability />} />
//         <Route path="/book/:id" element={<RoomBooking />} />


//         <Route path="/book/:id" element={<RoomBooking />} />
//    <Route path="/register" element={<Register />} />
//   <Route path="/history" element={<BookingHistory />} />

//      {/* New Routes User Sign in */}
//     <Route path="/manage-rooms" element={
//   <ProtectedRoute>
//     <ManageRooms />
//   </ProtectedRoute>
// } />
//       </Routes>
//     </BrowserRouter>



//   );
// }


// import React from "react";
// import { BrowserRouter, Routes, Route} from "react-router-dom";

// import Navbar from "./components/Navbar";
// import ProtectedRoute from "./components/ProtectedRoute";
// import Footer from "./components/Footer";

// // PAGES
// import HomePage from "./pages/HomePage";
// import Login from "./pages/Login";
// import Register from "./pages/Register";
// import AdminLogin from "./pages/AdminLogin";

// import ManageRooms from "./pages/ManageRooms";
// import AddRoom from "./pages/AddRoom";
// import EditRoom from "./pages/EditRoom";

// import BookingPage from "./pages/BookingPage";
// import BookingHistory from "./pages/BookingHistory";
// import ContactUs from "./pages/ContactUs";
// import AdminContacts from "./pages/AdminContacts";
// import Activities from "./pages/Activities";
// import AdminBookings from "./pages/AdminBookings";


// export default function App() {
//   // Hide navbar on login/register/admin-login
//   const hideNavbarPaths = ["/login", "/register", "/admin-login"];
//   const hideNavbar = hideNavbarPaths.includes(window.location.pathname);
//    //const hideNavbar = hideNavbarPaths.includes(location.pathname);
//   return (
//     <BrowserRouter>
//       {!hideNavbar && <Navbar />}

//       <Routes>
//         {/* PUBLIC ROUTES */}
//         <Route path="/" element={<HomePage />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/admin-login" element={<AdminLogin />} />
//         <Route path="/register" element={<Register />} />

//         {/* ADMIN ONLY */}
//         <Route
//           path="/admin/manage-rooms"
//           element={
//             <ProtectedRoute role="ADMIN">
//               <ManageRooms />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/admin/add-room"
//           element={
//             <ProtectedRoute role="ADMIN">
//               <AddRoom />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/admin/edit-room/:id"
//           element={
//             <ProtectedRoute role="ADMIN">
//               <EditRoom />
//             </ProtectedRoute>
//           }
//         />

//           {/* <Route
//   path="/admin/contacts"
//   element={
//     <ProtectedRoute role="ADMIN">
//       <AdminContacts />
//     </ProtectedRoute>
//   }
// /> */}


// <Route
//   path="/admin/bookings"
//   element={
//     <ProtectedRoute role="ADMIN">
//       <AdminBookings />
//     </ProtectedRoute>
//   }
// />



// <Route path="/activities" element={<Activities />} />


//  <Route path="/contact" element={<ContactUs />} />

// <Route
//   path="/admin/contact-messages"
//   element={
//     <ProtectedRoute role="ADMIN">
//       <AdminContacts />
//     </ProtectedRoute>
//   }
// />


//         {/* USER ONLY */}
//         <Route
//           path="/booking/:roomId"
//           element={
//             <ProtectedRoute role="USER">
//               <BookingPage />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/booking-history"
//           element={
//             <ProtectedRoute role="USER">
//               <BookingHistory />
//             </ProtectedRoute>
//           }
//         />
//       <Route 
//       path="/contact" 
//       element={<ContactUs />} 
//       />

//       </Routes>

//        <Footer />
//     </BrowserRouter>
//   );
// }

//******Changed for UI Design only ***** */
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import HomePage from "./pages/HomePage";
import AboutUs from "./pages/AboutUs";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminLogin from "./pages/AdminLogin";

import ManageRooms from "./pages/ManageRooms";
import AddRoom from "./pages/AddRoom";
import EditRoom from "./pages/EditRoom";

import BookingPage from "./pages/BookingPage";
import BookingHistory from "./pages/BookingHistory";
import ContactUs from "./pages/ContactUs";
import AdminContacts from "./pages/AdminContacts";
import AdminBookings from "./pages/AdminBookings";
import Services from "./components/Services";
import RoomList from "./components/RoomList";
import Activity from "./pages/Activity";
import AdminDashboard from "./pages/AdminDashboard";
import AdminRoute from "./routes/AdminRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./layouts/AdminLayout";


function AppContent() {
  const location = useLocation();
  const hideNavbarPaths = ["/login", "/admin-login"];
  const shouldHideNavbar = hideNavbarPaths.includes(location.pathname);

  return (
    <>
      {!shouldHideNavbar && <Navbar />}

      <Routes>
        {/* PUBLIC */}
        <Route path="/" element={<HomePage />} />
        
        <Route path="/login" element={<Login />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/register" element={<Register />} />
        <Route path="/about" element={<AboutUs />} />

        

        {/* ADMIN ROUTES */}
        <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/admin/manage-rooms" element={<AdminRoute><ManageRooms /></AdminRoute>} />
        
        <Route path="/admin/add-room" element={<AdminRoute><AddRoom /></AdminRoute>} />
        <Route path="/admin/edit-room/:id" element={<AdminRoute><EditRoom /></AdminRoute>} />
        <Route path="/admin/bookings" element={<AdminRoute><AdminBookings /></AdminRoute>} />
        <Route path="/admin/contact-messages" element={<AdminRoute><AdminContacts /></AdminRoute>} />
        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>} />
  
        {/* USER ROUTES */}
        <Route path="/booking/:roomId" element={<ProtectedRoute role="USER"><BookingPage /></ProtectedRoute>} />
        <Route path="/booking-history" element={<ProtectedRoute role="USER"><BookingHistory /></ProtectedRoute>} />

        {/* MISC */}
         <Route path="/rooms" element={<RoomList />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>

      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
